export { LottieAnimation } from './LottieAnimation';
